import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, signal, SimpleChanges, TemplateRef, ViewChild, WritableSignal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription, take } from 'rxjs';
import { markForValidation } from '../../functions/mark-for-validation.function';

@Component({
  selector: 'cec-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule],
})
export class DialogComponent implements OnChanges, OnDestroy {

    @ViewChild('dialog') dialogTemplate: TemplateRef<any>;

    private initialValue: unknown | null = null;

    @Input()
    public headerText = '';

    @Input()
    public headerKey = '';

    @Input()
    public subTitle = '';

    @Input()
    public formGroup: FormGroup | undefined = undefined;

    @Input()
    public width: string | undefined = undefined;

    @Input()
    public hideConfirmButton = false;

    @Input()
    public disableConfirmButton = false;

    protected valid: WritableSignal<boolean> = signal(true);

    @Output()
    public onButtonClicked = new EventEmitter<boolean>();

    @Output()
    public onClosed = new EventEmitter<void>();
    
    private sub = new Subscription();

    constructor(public dialog: MatDialog) {
        this.sub = this.dialog.afterAllClosed.subscribe(() => {
            if (this.formGroup) {
                this.formGroup.reset({...this.initialValue as object});
            }
            this.onClosed.emit();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.formGroup) {
            this.initialValue = this.formGroup.getRawValue();
        }
    }

    ngOnDestroy(): void {
        this.sub.unsubscribe();
    }

    public show(data?: unknown): void {
        this.dialog.open(this.dialogTemplate, { data: data, panelClass: 'panel-container', width: this.width });
    }

    public hide(): void {
        this.dialog.closeAll();
    }

    protected onClickButton(success: boolean): void {
        if (this.formGroup && success) {
            markForValidation(this.formGroup);

            if (!this.formGroup.valid) {
                return;
            }
        }
        this.onButtonClicked.emit(success);
        this.hide();
    }
}

